
import React from 'react';
import './SearchBar.css';


/*
class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    //this.state = {term: ''};
    this.handleSearch = this.handleSearch.bind(this);
    this.handleTermChange = this.handleTermChange.bind(this);
  }

  handleSearch(e) {
    this.props.onSearch(this.state.term);
    e.preventDefault();
  }

  handleTermChange(e) {
    this.setState({term: e.target.value});
  }

  render() {
    return (
      <div className="SearchBar">
        <input placeholder="Enter A Song Title or artist" onChange={this.handleTermChange}/>
        <a onClick={this.handleSearch}>SEARCH</a>
      </div>
    )
  }

}

export default SearchBar;
*/

class SearchBar extends React.Component {

  constructor(props){
    super(props);
    
    this.handleSearch = this.handleSearch.bind(this);
    this.handleTermChange = this.handleTermChange.bind(this);
   this.theKeyPress = this.theKeyPress.bind(this);
  }

  handleTermChange(event) {
    this.setState({term: event.target.value});
  }
  
  theKeyPress(event){
    const keyName = event.charCode;
    if(keyName === 13){
      event.preventDefault();
      this.props.onSearch(this.state.term);
    }
  }
  handleSearch(event) {
    this.props.onSearch(this.state.term);
  }

  render() {
    return (
     <form onKeyPress={this.theKeyPress}>
      <div id="SearchBar"className="SearchBar">
        <input onkeypress="keyup()" placeholder="Enter A Song, Album, or Artist" onChange={this.handleTermChange} />
        <a  onClick={this.handleSearch}>SEARCH</a>
      </div>
    </form>
    );
  }
}

export default SearchBar;






// WEBPACK FOOTER //
// ./src/Components/SearchBar/SearchBar.js